$(document).ready(function () {
  if ($("#custom_user_report_errors").length > 0) {
    alert($("#custom_user_report_errors").val());
  }

  $("input[id^='user_options_']").click(function (event) {
    check_step_3();
  });

  $("input[id^='course_options_']").click(function (event) {
    check_step_3();
  });

  $("input[id^='story_options_']").click(function (event) {
    check_step_3();
  });

  $("input[id^='chapter_options_']").click(function (event) {
    check_step_3();
  });

  $("input[id^='page_options_']").click(function (event) {
    check_step_3();
  });

  $("#goto-step3").click(function (e) {
    $('#custom-report-step3').find('input:checkbox:checked').each(function () {
      this.checked = false;
    });
    $('#custom-report-step3').css("display", "block");
    $('#user-search-group-selection-container').css("display", "none");
    $('#users-selection-container').css("display", "none");
    $('#goto-step4').css("opacity", ".2");
    $('#goto-step4').css("pointer-events", "none");
  });

  $('.step-5-save-report-checkbox').on('change', function(){
    if(this.checked){
      $('.inputs_reporting_saving').css("display", "block");
    }else{
      $('.inputs_reporting_saving').css("display", "none");
    }
  });

  custom_report_last_step();
});

function check_step_3()
{
  if (($("input[name='course_options[]']").is(':checked')) || ($("input[name='story_options[]']").is(':checked')) || ($("input[name='chapter_options[]']").is(':checked')) || ($("input[name='page_options[]']").is(':checked'))) {
    $(".generate-btns").children().css("opacity", "1");
    $(".generate-btns").children().css("pointer-events", "all");
    $('#goto-step4').val("Next");
    $('#custom-report-step4').css("display", "none");
    $('#custom-report-step5').css("display", "none");
    $("#goto-step4").unbind("click");
  }
  else if ($("input[name='user_options[]']").is(':checked')) {
    $(".generate-btns").children().css("opacity", "1");
    $(".generate-btns").children().css("pointer-events", "all");
    $('#goto-step4').val("Next");
    $('#custom-report-step4').css("display", "none");
    $("#goto-step4").unbind("click");
    $("#goto-step4").click(function (e) {
      e.preventDefault();
      $('#custom-report-step5').css("display", "block");
    });
  }
  else {
    $(".generate-btns").children().css("opacity", ".2");
    $(".generate-btns").children().css("pointer-events", "none");
    $('#goto-step4').val("Next");
    $('#custom-report-step4').css("display", "none");
    $('#custom-report-step5').css("display", "none");
    $("#goto-step4").unbind("click");
  }
}

window.generate_custom_report = function () {
  const data = {
    users: $.map($("input[name='users[]']:checked"), function (element, index) {
      return parseInt($(element).val());
    }),
    courses: $.map($("input[name='courses']:checked"), function (element, index) {
      return parseInt($(element).val());
    }).join(","),
    groups: $.map($("input[name='groups']:checked"), function (element, index) {
      return parseInt($(element).val());
    }).join(","),
    user_options: $.map($("input[name='user_options[]']:checked"), function (element, index) {
      return $(element).val();
    }).join(","),
    course_options: $.map($("input[name='course_options[]']:checked"), function (element, index) {
      return $(element).val();
    }).join(","),
    course_selected: $.map($("input[name='step_4_courses[]']:checked"), function (element, index) {
      return parseInt($(element).val());
    }).join(","),
    story_options: $.map($("input[name='story_options[]']:checked"), function (element, index) {
      return $(element).val();
    }).join(","),
    story_selected: $.map($("input[name='step_4_functions[]']:checked"), function (element, index) {
      return parseInt($(element).val());
    }).join(","),
    chapter_options: $.map($("input[name='chapter_options[]']:checked"), function (element, index) {
      return $(element).val();
    }).join(","),
    chapter_selected: $.map($("input[name='step_4_chapters[]']:checked"), function (element, index) {
      return parseInt($(element).val());
    }).join(","),
    page_options: $.map($("input[name='page_options[]']:checked"), function (element, index) {
      return $(element).val();
    }).join(","),
    page_selected: $.map($("input[name='step_4_pages[]']:checked"), function (element, index) {
      return parseInt($(element).val());
    }).join(","),
    group_report_start_day: $("input[name='group_report_start_day']").val(),
    group_report_end_day: $("input[name='group_report_end_day']").val(),
    template: "custom",
    country_tags: $('#report_country_tags').val(),
    office_tags: $('#report_office_tags').val(),
    role_tags: $('#report_role_tags').val(),
    save_report: $("input[name='save_report']").is(':checked'),
    scheduled_report_name: $("input[name='scheduled_report_name']").val(),
    scheduled_report_frequency: $('#scheduled_report_frequency').val(),
    this_week_new_hires: $('#this_week_new_hires').is(':checked') ? '1' : '0'    
  };

  const form = $('<form>', {
    action: '/reports/custom_report',
    method: 'POST'
  });

  $.each({
    courses: data.courses,
    users: data.users,
    groups: data.groups,
    user_options: data.user_options,
    course_options: data.course_options,
    course_selected: data.course_selected,
    story_options: data.story_options,
    story_selected: data.story_selected,
    chapter_options: data.chapter_options,
    chapter_selected: data.chapter_selected,
    page_options: data.page_options,
    page_selected: data.page_selected,
    group_report_start_day: data.group_report_start_day,
    group_report_end_day: data.group_report_end_day,
    template: data.template,
    country_tags: data.country_tags,
    office_tags: data.office_tags,
    role_tags: data.role_tags,
    save_report: data.save_report,
    scheduled_report_name: data.scheduled_report_name,
    scheduled_report_frequency: data.scheduled_report_frequency,
    this_week_new_hires: data.this_week_new_hires,
    authenticity_token: $("meta[name=\"csrf-token\"]").attr("content")
  }, function (key, val) {
    $('<input>').attr({
      type: "hidden",
      name: key,
      value: val
    }).appendTo(form);
  });
  form.appendTo('body').submit();
  form.remove();
}

window.custom_report_last_step = function () {
  $("#custom_generate_report").unbind("click");
  $("#custom_generate_report").click(function (e) {
    e.preventDefault();
    const report_name = $("input[name='scheduled_report_name']").val() || ''
    const report_checkbox = $("input[name='save_report']")
    if(report_checkbox.is(':checked') && !report_name.trim()){
      alert("please add report name");
    }else{
      generate_custom_report();
      if(report_checkbox.is(':checked') && !!report_name.trim()){
        alert("Your report has been saved, which you can find under Scheduled reports in Reporting.");
        $('#scheduled_report_name').val('');
        $('#save_report').click();
      }
    }
  });

  $("#show-final-step").click(function (e) {
    e.preventDefault();
    $('#final-step-title').html("STEP 5");
    $('#custom-report-step5').css("display", "block");
  });
}
